import ReactDatePicker from 'react-datepicker';
import React, {useEffect, useState} from 'react';
import dateFormat from 'dateformat';

interface DatePickerProps {
    id?: string;
    maxDate?: string;
    minDate?: string;
    selected?: string | null;
    isClearable?: boolean;
    onChange: (e: string) => any;
    dateMask?: string;
    className?: string;
    customInput?: React.ReactElement;
    portalId?: string;
}

/**
 * Custom date picker component which works with
 * date as a string in the format of yyyy-mm-dd (for parsing LocalDate in backend springframework).
 * If isClearable is set to true, onChange will not return a correct date string, but instead
 * will return a string: 'cleared', which should be handled by the component using this datePicker.
 *
 * @param maxDate
 * @param minDate
 * @param selected
 * @param onChange
 * @param isClearable
 * @param dateMask
 * @param className
 * @constructor
 */
export const DatePickerWrapper = ({
    id,
    maxDate,
    minDate,
    selected = null,
    onChange,
    isClearable = false,
    dateMask = 'dd/MM/yyyy',
    className = '',
    customInput,
    portalId,
}: DatePickerProps) => {
    const [selectedDate, setSelectedDate] = useState<Date | null>(selected ? new Date(selected) : null);

    useEffect(() => {
        setSelectedDate(selected ? new Date(selected) : null);
    }, [selected]);

    return (
        <ReactDatePicker
            id={id}
            maxDate={maxDate ? new Date(maxDate) : new Date(3000, 0, 1)}
            minDate={minDate ? new Date(minDate) : new Date(1900, 0, 1)}
            selected={selectedDate}
            onChange={(date) => {
                onChange(
                    date
                        ? dateFormat(date, 'yyyy-mm-dd')
                        : isClearable
                        ? 'cleared'
                        : dateFormat(new Date(), 'yyyy-mm-dd')
                );
                setSelectedDate(date);
            }}
            dateFormat={dateMask}
            customInput={customInput}
            portalId={portalId}
            className={customInput ? className : `border border-secondary text-start p-2 py-1 rounded w-100 ${className}`}
            onChangeRaw={(e) => {
                e.preventDefault();
            }}
            popperPlacement={portalId ? 'bottom-start' : 'bottom-end'}
            isClearable={isClearable}
        />
    );
};
